module.exports = "/_next/static/images/e69f3a1c1cf050a35e591d4651d7c52a-defer.png.webp";